import React, { useState, useMemo, useEffect } from "react";
import Form from "react-bootstrap/Form";
import Panel from "../Panel";
import { defaultLocalFont, fonts, webFontsPromise } from "../../utils/fonts";
import ChantDocument from "../../js/ChantDocument";

const FontPane = ({ handleFontChange, selectedValue }) => {
  const [webFonts, setWebFonts] = useState([]);
  const allFonts = useMemo(() => [...webFonts, ...fonts], [webFonts]);
  useEffect(() => {
    webFontsPromise.then(webFonts => {
      const allFonts = [...webFonts, ...fonts];
      if (!allFonts.includes(selectedValue)) {
        handleFontChange(
          [ChantDocument.defaultFont, defaultLocalFont].find(
            font => allFonts.includes(font) || allFonts[0]
          )
        );
      }
      setWebFonts(webFonts);
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return <>
    <Panel.Label>Font</Panel.Label>
    <Form.Control
      as="select"
      value={selectedValue}
      onChange={e => handleFontChange(e.target.value)}
    >
      {allFonts.map(font => (
        <option key={font} value={font}>
          {font}
        </option>
      ))}
    </Form.Control>
  </>;
};

export default FontPane;
